import React from 'react';
import { Box } from '@mui/material';
import { SvgIconProps } from '@mui/material/SvgIcon';
import Tooltip from '@mui/material/Tooltip';
import { TooltipProps } from '@mui/material/Tooltip/Tooltip';

import { Icon } from '@sdb/planning-ui';
import type { IconType } from '@sdb/planning-ui/ui-3/packages/icons/__generated__';

export interface IconTooltipProps {
  icon?: IconType;
  color?: SvgIconProps['color'];
  title: string;
  placement?: TooltipProps['placement'];
  fontSize?: 'medium' | 'small';
}

export const IconTooltip: React.FC<IconTooltipProps> = ({
  icon = 'circle-info',
  color = 'info',
  title,
  fontSize = 'medium',
  placement = 'bottom'
}) => (
  <Box padding={1}>
    <Tooltip title={title} placement={placement}>
      <Icon type={icon} color={color} fontSize={fontSize} />
    </Tooltip>
  </Box>
);
